import { useContext, useEffect, useState } from 'react';
import './Pitis.scss';
import { UserContext } from '../../../js/UserContext';
import NotAuthenticated from '../../../components/NotAuthenticated/NotAuthenticated';
import GenericPage from '../../../components/GenericPage/GenericPage';
import api from '../../../js/api';
import Menu from '../../../components/Menu/Menu';
import Button from '../../../components/Button/Button';

export default function Pitis() {

    const { user, loading } = useContext(UserContext);

    const [pitis, setPitis] = useState(null);

    const current_year = new Date().getFullYear();

    useEffect(() => {
        api.get('/user/cigars/' + current_year).then((pitis) => {
            if (pitis.error)
                return console.error(pitis.error);
            setPitis(pitis);
        })
    }, [])

    const calculatePitimetrics = () => {
        const pitimetrics = {}
        pitis.forEach((piti) => {
            const date = piti.slice(0, 10);
            const today = new Date().toISOString().slice(0, 10);
            // pitis smoked this month
            if (date === today)
                pitimetrics.today = (pitimetrics.today || 0) + 1;
            // pitis smoked this week
            const date1 = new Date(date);
            const date2 = new Date(today);
            const diffTime = Math.abs(date2 - date1);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays <= 7)
                pitimetrics.week = (pitimetrics.week || 0) + 1;

            // pitis smoked this month
            const month = date.slice(0, 7);
            if (month === today.slice(0, 7))
                pitimetrics.month = (pitimetrics.month || 0) + 1;
            // pitis smoked this year
            const year = date.slice(0, 4);
            if (year === today.slice(0, 4))
                pitimetrics.year = (pitimetrics.year || 0) + 1;
            // pitis smoked all time
            pitimetrics.all = (pitimetrics.all || 0) + 1;
        });

        pitimetrics.hours_lost = Math.floor(pitimetrics.all * 0.5);
        pitimetrics.days_lost = Math.floor(pitimetrics.hours_lost / 24);
        pitimetrics.weeks_lost = Math.floor(pitimetrics.days_lost / 7);

        pitimetrics.money_wasted = pitimetrics.all * 0.09;
        return (
            <div className='piti-metrics'>
                <br />
                <div className='pitimetric-row'><p><b>Today:</b></p> <p>{pitimetrics.today || 0}</p></div>
                <div className='pitimetric-row'><p><b>This week:</b></p> <p>{pitimetrics.week || 0}</p></div>
                <div className='pitimetric-row'><p><b>This month:</b></p> <p>{pitimetrics.month || 0}</p></div>
                <div className='pitimetric-row'><p><b>This year:</b></p> <p>{pitimetrics.year || 0}</p></div>
                <div className='pitimetric-row'><p><b>All time:</b></p> <p>{pitimetrics.all || 0}</p></div>
                <br />
                <div className='pitimetric-row'><p><b>Hours lost:</b></p> <p>{pitimetrics.hours_lost || 0}</p></div>
                <div className='pitimetric-row'><p><b>Days lost:</b></p> <p>{pitimetrics.days_lost || 0}</p></div>
                <div className='pitimetric-row'><p><b>Weeks lost:</b></p> <p>{pitimetrics.weeks_lost || 0}</p></div>
                <br />
                <div className='pitimetric-row'><p><b>Money wasted (euros):</b></p> <p>{pitimetrics.money_wasted || 0}</p></div>

            </div>
        )
    }

    if (loading)
        return <GenericPage title="Loading..." message="Please wait while we load your data." />;
    if (!user)
        return <NotAuthenticated />;
    if (user.error)
        return <GenericPage title="Error" message={user.error} />;
    if (!user.roles || !user.roles.includes('smoker'))
        return <GenericPage title="Access Denied" message="This page is only for smokers who are trying to quit. If you don't smoke, get lost." backbutton="true" />;

    return (
        <div id='pitis'>
            <div className='centered-container'>
                <h1>Pitis</h1>
                <br />
                <br />
                <div className="content">
                    <p>Welcome to the <b>Pitis</b> page!</p>
                    <br />
                    <p>Here you can find information about Pitis.</p>
                    <br />
                    <p>Press the button below to <b>smoke a Piti.</b></p>
                    <br />
                    <Button text="Smoke a Piti" onClick={async () => {
                        const r = await api.post(`/user/cigar`);
                        if (r.error)
                            return alert(r.error);
                        alert('Piti smoked! Now you are closer to quitting (or dying).');
                        window.location.reload();
                    }} />
                    <br />
                    <p>Here are your Piti metrics:</p>
                    {pitis ? (
                        calculatePitimetrics()
                    ) : (
                        <p>Loading...</p>
                    )}
                    <br />
                    <Menu title="" options={[
                        { name: 'Go Back', path: '/..' },
                    ]} />
                </div>
            </div>
        </div>
    );
}